import BigNumber from 'bignumber.js'
import { useTranslation } from '@pancakeswap/localization'
import { getBalanceAmount } from '@pancakeswap/utils/formatBalance'

import { useMemo } from 'react'

export const useUserEnoughCakeValidator = (cakeAmount: string, stakingTokenBalance: BigNumber) => {
  const { t } = useTranslation()
  const errorMessage = t('Insufficient BBC balance')

  const userNotEnoughCake = useMemo(() => {
    if (new BigNumber(cakeAmount).gt(getBalanceAmount(stakingTokenBalance, 18))) return true
    return false
  }, [cakeAmount, stakingTokenBalance])
  return { userNotEnoughCake, notEnoughErrorMessage: errorMessage }
}

export const useUserEnoughTokenValidator = (tokenAmount: string, stakingTokenBalance: BigNumber, tokenSymbol: string, tokenDecimals: number) => {
  const { t } = useTranslation()
  const errorMessage = t('Insufficient %symbol% balance', {Symbol: tokenSymbol})

  const userNotEnoughCake = useMemo(() => {
    if (new BigNumber(tokenAmount).gt(getBalanceAmount(stakingTokenBalance, tokenDecimals))) return true
    return false
  }, [tokenAmount, stakingTokenBalance, tokenDecimals])
  return { userNotEnoughCake, notEnoughErrorMessage: errorMessage }
}
